// extracted by mini-css-extract-plugin
export default {"buttonContainer":"e7dd01f5f70c","userList":"cae4312fdf9d","productList":"c1f866e6b8b9"};